import axios from "axios";

export const zipCloudServices = {
  async getAddress(zipCode: string) {
    return await axios.get(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipCode}`);
  }
}
